import { render, staticRenderFns } from "./FormAnswerInput.vue?vue&type=template&id=6e71bcaa&scoped=true&"
import script from "./FormAnswerInput.vue?vue&type=script&lang=js&"
export * from "./FormAnswerInput.vue?vue&type=script&lang=js&"
import style0 from "./FormAnswerInput.vue?vue&type=style&index=0&id=6e71bcaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e71bcaa",
  null
  
)

export default component.exports